import { FC } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuthContext } from '@/context/AuthContext.tsx';
import Middleware from '@/router/middleware/index.tsx';
import { canConfirmTrip, onboardingRouteFor } from '@/utils/onboarding/onboardingRoute.ts';

const OnboardingTripReady: FC = () => {
  const { user, isLoading } = useAuthContext();

  return (
    <Middleware isLoading={isLoading}>
      {canConfirmTrip(user?.onboarding_step) ? <Outlet /> : <Navigate to={onboardingRouteFor(user?.onboarding_step)} />}
    </Middleware>
  );
};

export default OnboardingTripReady;
